//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Builder.js";
import "../no/SelectCurveList.js";
import "../no/SelectNXObjectList.js";
import "../no/ugmath.js";
import "../no/SelectObjectList.js";
let d=[[[1,"BoundaryCurves",0,"SelectCurveList",1],[1,"BoundaryObjects",0,"SelectNXObjectList",0],[0,"ExtendBound",1,0],[1,"TrimmedCurves",0,"SelectCurveList",0]],[[["trimCurve","helpPoint","nParams"],"FindTrimRegion",{R_:{trimRange:""}},2,0]],[]];
SPLM.SketchQuickTrimBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.SketchQuickTrimBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;